import { render } from "./SplashLayout.vue?vue&type=template&id=3b7d1d3f"
import script from "./SplashLayout.vue?vue&type=script&lang=js"
export * from "./SplashLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__